import { c as _c } from "react/compiler-runtime";
import Icon from "@/components/icon";
import { useClubsFiltersOpenedStore, useClubsFiltersStore } from "@/stores/clubs-filters-store";
import { IconType } from "@/TS/Types/global_types";
interface ClubFilterFormatItemProps {
  color: string;
  label: string;
  description: string;
  icon: IconType;
  value: "weekly" | "fortnightly" | "monthly";
}
export default function ClubFilterFormatItem(t0) {
  const $ = _c(20);
  const {
    icon,
    color,
    label,
    description,
    value
  } = t0;
  const setFiltersFormat = useClubsFiltersStore(_temp);
  const setFiltersClosed = useClubsFiltersOpenedStore(_temp2);
  let t1;
  if ($[0] !== setFiltersClosed || $[1] !== setFiltersFormat || $[2] !== value) {
    t1 = () => {
      setFiltersFormat(value);
      setFiltersClosed();
    };
    $[0] = setFiltersClosed;
    $[1] = setFiltersFormat;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `flex flex-col justify-center items-center w-[40px] h-[40px] bg-${color} rounded-[5px]`;
  let t3;
  if ($[4] !== icon) {
    t3 = <Icon icon={icon} size={30} className="text-white" />;
    $[4] = icon;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== label) {
    t5 = <p className=" font-bold">{label}</p>;
    $[9] = label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== description) {
    t6 = <p className="text-grey text-sm">{description}</p>;
    $[11] = description;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="flex flex-col">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t4 || $[18] !== t7) {
    t8 = <div className="flex flex-row justify-start items-start gap-3 hover:cursor-pointer hover:bg-light-grey p-2 rounded-[5px]" onClick={t1}>{t4}{t7}</div>;
    $[16] = t1;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(state_0) {
  return state_0.setFiltersClosed;
}
function _temp(state) {
  return state.setFormat;
}